import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import IconTile from "./IconTile";

interface PageHeaderProps {
  icon?: React.ReactNode;
  title: string;
  /** Inline element rendered next to the title (e.g. an ID chip). */
  titleAdornment?: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, titleAdornment, subtitle, actions }) => (
  <Stack direction="row" sx={{ alignItems: "center", gap: "16px", mb: "24px" }}>
    {icon && <IconTile>{icon}</IconTile>}
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Stack direction="row" sx={{ alignItems: "center", gap: "8px" }}>
        <Typography sx={{ fontWeight: 800, fontSize: { xs: "1.1rem", md: "1.375rem" } }} noWrap>{title}</Typography>
        {titleAdornment}
      </Stack>
      {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
    </Box>
    {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
  </Stack>
);

export default PageHeader;
